import RichText from "@/components/RichText";
import { SmartLink } from "../components/Primitives";
import { BODY, BTN_FILL, BTN_OUTLINE, CONTAINER, DARK_BG, SECTION } from "../tokens";

// Présentation sur deux colonnes : titre, filet, paragraphes, adresse et
// deux boutons / photo de l'atelier pleine hauteur (min 340px).
export default function IntroSplitSection({ props = {} }) {
  const imageLeft = props.image_position === "left";
  const photo = (
    <div className="self-stretch min-h-[340px]" style={DARK_BG}>
      {props.image_url && (
        <img
          src={props.image_url}
          alt={props.alt || ""}
          className="w-full h-full min-h-[340px] object-cover block"
          loading="lazy"
        />
      )}
    </div>
  );

  return (
    <section>
      <div className={`${CONTAINER} ${SECTION} grid gap-10 md:gap-12 [grid-template-columns:repeat(auto-fit,minmax(300px,1fr))]`}>
      {imageLeft && photo}
      <div>
        <RichText
          as="h2"
          className="font-display font-normal text-[clamp(24px,2.4vw,31px)] leading-[1.3] text-ink [text-wrap:pretty]"
          html={props.heading}
        />
        <span className="block w-12 h-px bg-ink/25 my-7" aria-hidden="true" />
        <RichText as="div" preserveParagraphs className={`${BODY} [&_p]:mb-5 [&_p:last-child]:mb-0`} html={props.body} />
        {props.address_line && (
          <div className="mt-7 text-[12px] tracking-[0.16em] uppercase text-ash">{props.address_line}</div>
        )}
        {(props.cta_primary_label || props.cta_secondary_label) && (
          <div className="flex flex-wrap gap-3 mt-7">
            {props.cta_primary_label && (
              <SmartLink url={props.cta_primary_url || "/savoir-faire"} className={BTN_FILL}>
                {props.cta_primary_label}
              </SmartLink>
            )}
            {props.cta_secondary_label && (
              <SmartLink url={props.cta_secondary_url || "/professionnels-contact#contact"} className={BTN_OUTLINE}>
                {props.cta_secondary_label}
              </SmartLink>
            )}
          </div>
        )}
      </div>
      {!imageLeft && photo}
      </div>
    </section>
  );
}
